export default "__VITE_ASSET__DmTwYAQw__"